import { Instrument } from '@cash-web/protos/squareup/franklin/api/instrument.pb'

export const updateInstruments = ({
  instruments,
  newInstrument,
}: {
  instruments: ReadonlyArray<Instrument>
  newInstrument: Instrument & { token: NonNullable<Instrument['token']> }
}) => {
  let hasUpdated = false

  const newInstruments = instruments.map(instrument => {
    if (instrument.token === newInstrument.token) {
      hasUpdated = true

      return {
        ...newInstrument,
      }
    }

    return instrument
  })

  if (!hasUpdated) {
    newInstruments.push(newInstrument)
  }

  return newInstruments
}
